import { render, staticRenderFns } from "./TooltipAjudaLista.vue?vue&type=template&id=6889ceee&lang=html&"
import script from "./TooltipAjudaLista.vue?vue&type=script&lang=js&"
export * from "./TooltipAjudaLista.vue?vue&type=script&lang=js&"
import style0 from "./TooltipAjudaLista.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VContainer,VIcon,VTooltip})
